import React from 'react';

const SuccessMessage = () => {
  return (
    <>
      <div
        id="email_sent"
        className="informational_message"
        style={{ marginTop: 15 }}
      >
        <span
          className="frg-icon icon-warning-inverted"
          style={{
            fontSize: 14,
            color: '#66cc00',
            marginRight: 5
          }}
        />
        <span className="frg-body-font-14px">
          {localStorage.getItem('locale') === 'FR' ? (
          <>
          <b>Remarque</b>: Un e-mail a été envoyé à votre adresse e-mail, veuillez cliquer sur le lien intégré pour réinitialiser votre mot de passe.
          </>): 
            (<>
            <b>Note</b>: An email has been sent to your email address, please
            click on the embedded link to reset your password.
          </>)
          }
        </span>
      </div>
    </>
  );
};

export default SuccessMessage;
